export const VERSION = 'dev-master#727c62a';
